import { useParams } from "react-router";
import { AuditGroupPlanTabId, AuditGroupTabs, LegalEntityAuditGroupOverviewModel } from "./LegalEntityAuditGroupOverview.types";
import { useDownloadLegalEntityAuditReport } from "../DowloadLegalEntityAuditReport.hooks.ts";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { useLocalStorageTab } from "@common/hooks/useLocalStorageTab";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useLegalEntityAuditGroupDialog() {
    const { id } = useParams<{ id: string }>();
    const { onDownloadReportAsPdf, isDownloadingPdf } = useDownloadLegalEntityAuditReport();
    const { customerId } = useUserContext();

    const [selectedTab, setSelectedTab] = useLocalStorageTab(`audit-group-plan-tab-${customerId}`, auditGroupPlanTabMapping, AuditGroupPlanTabId.Audits);

    const queryKey = `/legalEntityAuditGroups/${id}/overview`;
    let { isLoading, data, refetch } = useDotLegalQuery<LegalEntityAuditGroupOverviewModel>(queryKey);

    function onAuditGroupUpdated() {
        refetch();
    }
    return {
        auditGroupId: id!,
        isLoading,
        data,
        onAuditGroupUpdated,
        isDownloadingPdf,
        onDownloadReportAsPdf,
        refetch,
        selectedTab,
        setSelectedTab,
    };
}

const auditGroupPlanTabMapping: Record<number, AuditGroupPlanTabId> = {
    [AuditGroupTabs.Audits]: AuditGroupPlanTabId.Audits,
    [AuditGroupTabs.Tasks]: AuditGroupPlanTabId.Tasks,
};
